import Full from './full.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/corporate_governance/context';

function useSelfContext() {
	provideCurrentContext();
}

export const componentMap = {
	full: withProvider(Full, useSelfContext)
};
